export default __webpack_public_path__ + "static/media/logo_quadrado.9eedf24e.svg";